import type { HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?:
    | "default"
    | "success"
    | "warning"
    | "danger"
    | "info"
    | "primary"
    | "secondary"
    | "outline";
  size?: "sm" | "md" | "lg";
}

/** Badge — status/kind indicator pill. */
export function Badge({
  className,
  variant = "default",
  size,
  children,
  ...props
}: BadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ring-1 ring-inset",
        {
          "bg-bg-muted text-text-secondary ring-border-strong/50":
            variant === "default",
          "bg-success-light text-success ring-success/20": variant === "success",
          "bg-warning-light text-warning ring-warning/20": variant === "warning",
          "bg-danger-light text-danger ring-danger/20": variant === "danger",
          "bg-info-light text-info ring-info/20": variant === "info",
          "bg-copper-light text-copper ring-copper/20": variant === "primary",
          "bg-bg-muted text-text-primary ring-border-strong/50":
            variant === "secondary",
          "bg-transparent text-text-secondary ring-border-strong":
            variant === "outline",
        },
        {
          "px-2 py-0.5 text-xs": size === "sm",
          "px-2.5 py-0.5 text-xs": size === "md" || !size,
          "px-3 py-1 text-sm": size === "lg",
        },
        className,
      )}
      {...props}
    >
      {children}
    </span>
  );
}
